export const userMessages = {
  'fav.empty': '还没有收藏，去逛逛商品吧',
  'fav.goList': '去商品列表',
  'fav.line': '已收藏 {n} 件商品',
  'fav.loadFail': '加载收藏失败',
  'fav.title': '我的收藏',
  'forgotPassword.backLogin': '返回登录',
  'forgotPassword.error.generic': '重置失败，请重试',
  'forgotPassword.label.account': '账号',
  'forgotPassword.label.confirmPassword': '确认新密码',
  'forgotPassword.label.newPassword': '新密码',
  'forgotPassword.ph.account': '请输入账号',
  'forgotPassword.ph.confirmPassword': '再次输入新密码',
  'forgotPassword.ph.newPassword': '至少 6 位',
  'forgotPassword.submit': '确认重置',
  'forgotPassword.subtitle': '验证账号后设置新密码',
  'forgotPassword.success': '密码重置成功，即将跳转登录页',
  'forgotPassword.title': '重置密码',
  'login.error.generic': '登录失败，请重试',
  'login.footer.admin': '管理员登录后进入智能商品运营后台',
  'login.footer.customer': '未登录为游客仅可浏览；登录后可收藏、购物车与星级评价',
  'login.hint.admin': '演示管理员：admin / 123456',
  'login.hint.customer': '演示普通用户：user01 / 123456',
  'login.label.account': '账号',
  'login.label.password': '密码',
  'login.link.forgotPassword': '忘记密码？',
  'login.link.register': '还没有账号？立即注册',
  'login.ph.account': '请输入账号',
  'login.ph.password': '请输入密码',
  'login.submit.admin': '进入后台',
  'login.submit.mall': '进入商城',
  'login.subtitle': '请选择登录身份并进入对应系统',
  'login.tab.admin': '管理员',
  'login.tab.customer': '普通用户',
  'login.title': '欢迎回来',
  'register.error.generic': '注册失败，请重试',
  'register.error.passwordLength': '密码至少 6 位',
  'register.error.passwordMismatch': '两次输入的密码不一致',
  'register.hasAccount': '已有账号？去登录',
  'register.label.account': '账号',
  'register.label.confirmPassword': '确认密码',
  'register.label.password': '密码',
  'register.ph.account': '请输入账号',
  'register.ph.confirmPassword': '再次输入密码',
  'register.ph.password': '至少 6 位',
  'register.submit': '立即注册',
  'register.subtitle': '填写您的账号信息',
  'register.subtitle2': '设置您的个人资料',
  'register.title': '创建账号',
  'register.btn.next': '下一步',
  'register.btn.back': '上一步',
  'register.btn.randomAvatar': '随机生成',
  'register.label.displayName': '昵称',
  'register.label.email': '邮箱（可选）',
  'register.label.avatar': '选择头像',
  'register.ph.displayName': '您希望别人如何称呼您',
  'register.ph.email': '请输入邮箱地址',
  'user.linkAddress': '收货地址',
  'user.linkCart': '购物车',
  'user.linkFav': '我的收藏',
  'user.linkOrders': '我的订单',
  'user.linkShop': '继续购物',
  'user.noCity': '未填写城市',
  'user.since': '注册于',
  'user.statFav': '我的收藏',
  'user.statReviews': '高星评价次数（4～5 星）',
  'user.title': '用户中心',
  'user.edit.btn': '编辑资料',
  'user.edit.save': '保存',
  'user.edit.cancel': '取消',
  'user.edit.label.displayName': '昵称',
  'user.edit.label.avatar': '头像',
  'user.edit.label.email': '邮箱',
  'user.edit.label.city': '城市',
  'user.edit.randomAvatar': '随机生成头像',
  'user.edit.success': '资料已更新',
  'user.edit.error': '保存失败',
  'user.edit.ph.city': '请输入城市',
  'user.edit.ph.displayName': '请输入昵称',
  'user.edit.ph.email': '请输入邮箱',
};
